<form novalidate #currentForm="ngForm">
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Contact</label>
    <div class="col-sm-10">
      <app-contact-search [contactId]="vendor.contact_id" [include_item]="true" (contact)="onContactSelect($event)"></app-contact-search>
      <div class="mt-1" *ngIf="vendor.contact_id">
        Selected Contact:&nbsp;
        <a [href]="'/contacts/' + vendor.contact_id" target="_blank">{{ contact_name }}</a>
      </div>
      <div class="mt-1 text-danger" *ngIf="!vendor.contact_id && formSubmitted">Contact has to be selected</div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Address</label>
    <div class="col-sm-10">
      <select name="address_id" [(ngModel)]="vendor.address_id" required #address_id="ngModel" [ngClass]="{ 'form-control': true, 'is-valid': formSubmitted && vendor.address_id, 'is-invalid': formSubmitted && !vendor.address_id }" [disabled]="!vendor.contact_id">
        <option *ngFor="let address of addresses" [value]="address.value">{{ address.label }}</option>
      </select>
      <small class="form-text text-muted" *ngIf="!vendor.contact_id">Contact needs to be selected to get addresses</small>
      <div class="invalid-feedback" *ngIf="formSubmitted && !vendor.address_id">Address needs to be selected</div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Account #</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" name="account_number" [(ngModel)]="vendor.account_number" #account_number="ngModel" />
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Chart of Account</label>
    <div class="col-sm-10">
      <select [ngClass]="{ 'form-control': true, 'is-valid': formSubmitted && vendor.chart_of_account_id, 'is-invalid': formSubmitted && !vendor.chart_of_account_id }" [(ngModel)]="vendor.chart_of_account_id" #chart_of_account_id="ngModel" name="chart_of_account_id" required>
        <option *ngFor="let chart_of_account of formOptions.chart_of_accounts" [value]="chart_of_account.value">{{ chart_of_account.label }}</option>
      </select>
      <div class="invalid-feedback" *ngIf="formSubmitted && !vendor.chart_of_account_id">Chart of account needs to be selected</div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label"></label>
    <div class="col-sm-10">
      <div class="custom-control custom-control-inline custom-checkbox" (click)="vendor.is_auto_withdrawal = !vendor.is_auto_withdrawal">
        <input type="checkbox" class="custom-control-input" [checked]="vendor.is_auto_withdrawal" [(ngModel)]="vendor.is_auto_withdrawal" name="is_auto_withdrawal" />
        <label class="custom-control-label">Is Auto W/D</label>
      </div>
      <div class="custom-control custom-control-inline custom-checkbox" (click)="vendor.is_priority = !vendor.is_priority">
        <input type="checkbox" class="custom-control-input" name="is_priority" [checked]="vendor.is_priority" [(ngModel)]="vendor.is_priority" />
        <label class="custom-control-label">Is priority</label>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Description</label>
    <div class="col-sm-10">
      <textarea class="form-control" name="description" #description="ngModel" [(ngModel)]="vendor.description"></textarea>
    </div>
  </div>
  <div class="form-group row text-danger" *ngIf="formSubmitted && !validVendor()">
    <label class="col-sm-2 col-form-label"></label>
    <div class="col-sm-10">Some errors were found, please correct them</div>
  </div>
  <div class="form-group text-center">
    <button type="button" class="btn btn-primary" (click)="submitForm()">{{ vendor.id ? 'Update' : 'Create' }}</button>
    &nbsp;
    <app-button-back [buttonDisabled]="formSubmitting"></app-button-back>
  </div>
  <div class="py-3"></div>
</form>
